import React from 'react'
import '../styles/mandatoryHighlight.scss'

function withMandatoryHighlight(FieldComponent) {
  function Wrapped({ required, disabled, ...rest }) {
    return (
      <span className={required && !disabled ? 'mpci-mandatory' : undefined} style={{ display: 'contents' }}>
        <FieldComponent required={required} disabled={disabled} {...rest} />
      </span>
    )
  }
  return Wrapped
}

export default withMandatoryHighlight
